import React from 'react';
import { Field } from 'redux-form';
import { PageLink } from 'src/components/links';
import { Form } from 'src/components/tracking';
import { Button, Panel, Stack } from 'src/components/matchbox';
import LabelledValue from 'src/components/labelledValue/LabelledValue';
import { CheckboxWrapper } from 'src/components/reduxFormWrappers';
import RoleRadioGroup from './RoleRadioGroup';
import { ROLES } from 'src/constants';

export const EditForm = ({
  onSubmit,
  user,
  currentUser,
  isAccountSingleSignOnEnabled,
  subaccount,
  submitting
}) => {
  const isAuth0User = user?.auth_migrated;

  const ssoHelpText = (
    <span>
      Enabling single sign-on will delete this user's password. If they switch back to
      password-based authentication, they'll need to reset their password on login.
    </span>
  );
  const subaccountUser =
    user.access === ROLES.SUBACCOUNT_REPORTING || user.access === ROLES.SUBACCOUNT_DEVELOPER;

  const roleSection = subaccountUser ? (
    <Stack>
      {user.access === ROLES.SUBACCOUNT_REPORTING ? (
        <p>
          This user has access to reporting features and read-only template access, limited to a
          single subaccount. Its role can’t be changed.
        </p>
      ) : (
        <p>
          This user has full access to API Keys, and most other email related setup, sending, and
          reporting features, limited to a single subaccount. Its role can't be changed.
        </p>
      )}
      <LabelledValue label="Subaccount" name="subaccountInfo">
        <PageLink to={`/account/subaccounts/${subaccount.id}`}>{subaccount.name}</PageLink> (
        {subaccount.id})
      </LabelledValue>
    </Stack>
  ) : (
    <Field
      name="access"
      allowSubaccountAssignment={false}
      disabled={user.isCurrentUser}
      allowSuperUser={currentUser.access === ROLES.SUPERUSER}
      component={RoleRadioGroup}
      data-track={true}
    />
  );

  const hideUpdateUser = subaccountUser && !isAccountSingleSignOnEnabled;

  return (
    <Panel.LEGACY>
      <Form onSubmit={onSubmit} id="users-edit-form">
        <Panel.LEGACY.Section>{roleSection}</Panel.LEGACY.Section>
        {!isAuth0User && isAccountSingleSignOnEnabled && (
          <Panel.LEGACY.Section>
            <Field
              component={CheckboxWrapper}
              helpText={ssoHelpText}
              label="Enable single sign-on authentication for this user"
              name="is_sso"
              type="checkbox"
              data-track={true}
            />
          </Panel.LEGACY.Section>
        )}

        {!hideUpdateUser && (
          <Panel.LEGACY.Section>
            <Button variant="primary" disabled={submitting || user.isCurrentUser} submit>
              Update User
            </Button>
          </Panel.LEGACY.Section>
        )}
      </Form>
    </Panel.LEGACY>
  );
};

export default EditForm;
